import useQuery from './useQuery';

/** M9 slice 3 (#165): the seller's notification feed (paginated DRF envelope
 * with an extra `unread` count). Drives the top-bar bell — callers poll via
 * `refetchInterval` and gate `enabled` on a selected seller. */
function useNotificationsQuery(sellerId, params) {
  return useQuery('/notifications/', {
    enabled: Boolean(sellerId),
    queryParams: { seller: sellerId },
    ...params,
  });
}

export default useNotificationsQuery;
